import { axios } from './axios';
import { handleErrors } from './utils';

export function getUserData() {
    return new Promise((resolve, reject) => {
        axios
            .get(`/v1/sync/userdata`)
            .then(({ data }) => {
                resolve(data);
            })
            .catch(handleErrors(reject));
    });
}
